/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Name_PlaceholderInputs */

const en_admin_roles_name_placeholder = /** @type {(inputs: Admin_Roles_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. editor`)
};

/**
* | output |
* | --- |
* | "e.g. editor" |
*
* @param {Admin_Roles_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_name_placeholder = /** @type {((inputs?: Admin_Roles_Name_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Name_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_name_placeholder(inputs)
});
export { admin_roles_name_placeholder as "admin.roles.name_placeholder" }